export interface TrailObservationDto {
  id: string;
  type?: string | null;
  status?: string | null;
  note?: string | null;
  followUpOf?: string | null;
  latitude?: number | null;
  longitude?: number | null;
  hikerLatitude?: number | null;
  hikerLongitude?: number | null;
  positionAccuracy?: number | null;
  userId: string;
  userName?: string | null;
  deviceId?: string | null;
  observedAt: string;
  receivedAt: string;
  isDeleted: boolean;
  rawPayload: string;
}

export interface TrailObservationListResponse {
  reports: TrailObservationDto[];
  totalCount: number;
  page: number;
  pageSize: number;
  totalPages: number;
}

export interface TrailObservationStatsDto {
  totalObservations: number;
  observationsLast7Days: number;
  independentReporters: number;
  typeCounts: Record<string, number>;
}

/** Mirrors the app's ObservationType taxonomy (payload id → label). */
export const OBSERVATION_TYPE_LABELS: Record<string, string> = {
  vegetationOvergrown: 'Vegetation – overgrown',
  vegetationWindfall: 'Vegetation – windfall',
  poorDrainage: 'Track surface – poor drainage',
  muddy: 'Track surface – muddy',
  erosion: 'Track surface – erosion',
  markingMissing: 'Track marking – not present',
  signage: 'Signage – incorrect/missing',
  slip: 'Slip / unstable ground',
  structure: 'Structure issue',
  otherHazard: 'Other hazard',
  mapsInaccurate: 'Maps inaccurate',
  notesInaccurate: 'Notes inaccurate',
  campingOpportunity: 'Camping opportunity',
  wasps: 'Wasps seen',
  other: 'Other (see description)',
};

/** Marker/legend colour per category group. */
export const OBSERVATION_TYPE_COLORS: Record<string, string> = {
  vegetationOvergrown: '#16a34a',
  vegetationWindfall: '#16a34a',
  poorDrainage: '#92400e',
  muddy: '#92400e',
  erosion: '#92400e',
  markingMissing: '#d97706',
  signage: '#d97706',
  slip: '#dc2626',
  structure: '#dc2626',
  otherHazard: '#dc2626',
  wasps: '#dc2626',
  mapsInaccurate: '#2563eb',
  notesInaccurate: '#2563eb',
  campingOpportunity: '#0d9488',
  other: '#6b7280',
};
